import naja from 'naja';
import 'flowbite';

import Croppie from 'croppie';

import { initAllPageComponents } from './page-ui.js';
import { configureNaja } from './naja-setup.js';
import { initLineupEditors } from './lineup-editor.js';

// Croppie dáme do window, kdyby ho některé části aplikace potřebovaly globálně.
window.Croppie = Croppie;

// Naju dáme do window kvůli ladění, Tracy baru a dalším modulům.
window.naja = naja;

// Naja konfigurace pouze jednou.
if (!window.najaConfigured) {
    configureNaja(naja);
    window.najaConfigured = true;
}

// Inicializace aplikace pouze jednou.
document.addEventListener('DOMContentLoaded', () => {
    if (!window.najaInitialized) {
        naja.initialize();
        window.najaInitialized = true;
        console.log('Naja initialized');
    }

    initAllPageComponents(document);
    initLineupEditors(document);
    console.log('App initialized');
});

// The lineup module is part of this entry point and also handles replaced snippets.
naja.addEventListener('complete', () => initLineupEditors(document));
naja.snippetHandler.addEventListener('afterUpdate', () => initLineupEditors(document));
